import type { Season } from '../api';

interface Props {
  seasons: Season[];
  selected: string;
  onSelect: (id: string) => void;
}

/**
 * Season board switcher: All-Time is the perpetual board; the other seasons are
 * separate time-boxed boards over the same contributions. Rendered as a segmented
 * row of chips, reusing the cat-chip styling used by the Overall chip.
 */
export function SeasonSelector({ seasons, selected, onSelect }: Props) {
  if (seasons.length <= 1) return null;
  return (
    <div className="season-selector" role="group" aria-label="Season">
      {seasons.map((s) => (
        <button
          key={s.id}
          className={`cat-chip${selected === s.id ? ' is-active' : ''}`}
          aria-pressed={selected === s.id}
          onClick={() => onSelect(s.id)}
        >
          {s.name}
        </button>
      ))}
    </div>
  );
}
